import { render } from "./register.html?vue&type=template&id=72990457&ts=true&external"
import script from "./register.ts?vue&type=script&lang=ts&external"
export * from "./register.ts?vue&type=script&lang=ts&external"

import "./register.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__